import React from 'react';
import ICampus from '@/models/viewModels/ICampus';
import { MapIcon } from '@/components/atoms/icons';
import css from 'styled-jsx/css';
import { ImageComponent, RichText } from '@into-discovery/browsewebshared';

import campusStyles from './campus.module.scss';

type SingleCampus = {
  campus: ICampus;
  brandColor: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeCampus: (position: any) => void;
  disableAddressLink: boolean;
};

function getStyles(uniBackgroundColor: string): { className: string; styles: JSX.Element } {
  return css.resolve`
    .campus-primary::before {
      background-color: ${uniBackgroundColor};
    }
  `;
}

function getMarkerStyles(uniBackgroundColor: string): { className: string; styles: JSX.Element } {
  return css.resolve`
    .campus-primary-marker {
      background-color: ${uniBackgroundColor};
    }
  `;
}

export default function Campus({
  campus: { coordinates, address, displayName, introduction, promoImage, isPrimary, campusId },
  brandColor,
  onChangeCampus,
  disableAddressLink,
}: SingleCampus) {
  const { className, styles } = getStyles(brandColor);
  const markerStyles = getMarkerStyles(brandColor);
  return (
    <div
      id={`${campusId}-block`}
      className={`${isPrimary ? `${campusStyles.major} ${className} campus-primary` : ``} ${
        campusStyles.campus
      } card element-default-style bg-white rounded-border-6 `}
    >
      {styles}
      {isPrimary && (
        <span
          id="main-campus-marker"
          className={`${campusStyles.campus_marker} campus-primary-marker ${markerStyles.className} `}
        >
          {markerStyles.styles}
          Main campus
        </span>
      )}
      <div className="row g-0 align-items-stretch">
        {promoImage && (
          <div
            id={`${campusId}-image`}
            className={`${campusStyles.campus_image} col-lg-3 position-relative`}
          >
            <ImageComponent
              src={promoImage?.secureUrl}
              altText={promoImage.alt ?? `${displayName}`}
              sizes="256px"
            />
          </div>
        )}
        <div
          className={`${campusStyles.campus_content} ${
            promoImage ? `col-lg-9 pe-lg-7` : `col-lg-12`
          }`}
        >
          <h4 className="mb-2 mt-lg-2" id={`${campusId}-title`}>
            {displayName}
          </h4>
          <RichText richText={introduction} />
          {address && (
            <button
              type="button"
              id={`${campusId}-address`}
              onClick={() =>
                coordinates &&
                !disableAddressLink &&
                onChangeCampus({ lat: coordinates.latitude, lng: coordinates.longitude })
              }
              className={`${campusStyles.campus_address}
              ${disableAddressLink ? campusStyles.disabled : null} d-flex`}
            >
              <MapIcon />
              <span>{address}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
